import axios from 'axios';
import React, { useState, useEffect, useRef, useCallback } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight, MdRemoveRedEye } from "react-icons/md";
import { Tooltip } from 'react-tooltip';
import { ToastContainer, toast } from 'react-toastify';

import constant from '../../utils/Constant'
import config from '../../config/config';
import ReactPaginate from 'react-paginate';

const {
    BOOLEAN_FALSE: falseValue,
    QUOTATION_END_POINT,
    REQUESTED_RECORD,
    ZERO,
    ONE,
    STATUS_200,
    STATUS_401,
    LOGOUT,
    NULL,
    THREE,
    TWO
} = constant;

const AllQuotation = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const currentPage = location.state?.page || ONE;

    const [data, setData] = useState([]);
    const [page, setPage] = useState(currentPage);
    const [totalPages, setTotalPages] = useState(ONE);
    const [vendorStat, setVendorStat] = useState(THREE);
    const [openModal, setOpenModal] = useState(falseValue);
    const confirmationRef = useRef(NULL);

    //* disable scroll
    useEffect(() => {
        if (openModal) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };
    }, [openModal]);

    //* close modal when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (confirmationRef.current && !confirmationRef.current.contains(event.target)) {
                setOpenModal(falseValue);
            }
        };

        if (openModal) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openModal, setOpenModal,]);

    //* trap focus within modal when open
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Tab" && openModal) {
                const focusableElements = confirmationRef.current.querySelectorAll("button, input, select, textarea, a");
                if (focusableElements.length === 0) return;

                const firstElement = focusableElements[0];
                const lastElement = focusableElements[focusableElements.length - 1];

                //* prevent tabbing outside the modal
                if (event.shiftKey) {
                    if (document.activeElement === firstElement) {
                        lastElement.focus();
                        event.preventDefault();
                    }
                } else {
                    if (document.activeElement === lastElement) {
                        firstElement.focus();
                        event.preventDefault();
                    }
                }
            }
        };

        //* add event listener
        if (openModal) {
            document.addEventListener("keydown", handleKeyDown);
        } else {
            document.removeEventListener("keydown", handleKeyDown);
        }

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [openModal]);

    // * get token from local storage
    const token = localStorage.getItem('vendor_dashboard');

    // * execute quote request api
    const executeMobileQuoteApi = useCallback(async () => {
        try {
            const apiUrl = `${config.appBaseUrl + QUOTATION_END_POINT}/${vendorStat}?page=${page}`;

            // * execute get request
            const response = await axios.get(apiUrl, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            // * api response
            const result = response.data;

            // * if response is success
            if (result.code === STATUS_200 && result.status) {
                setData(result.data.data);
                setPage(page);
                setTotalPages(result.data.last_page);
            }
        } catch (error) {
            // * if token is expired
            if (error?.response?.data?.code === STATUS_401) {
                navigate(LOGOUT);
            }
            toast.error(error);
        }
    }, [navigate, token, page, vendorStat]);

    // * execute quote request api
    useEffect(() => {
        executeMobileQuoteApi();
    }, [executeMobileQuoteApi, token, page, vendorStat]);

    // * handle page change
    const handlePageChange = (selectedPage) => {
        const newPage = selectedPage.selected + ONE;
        setPage(newPage);
        navigate('/quotation/all', { state: { page: newPage } });
    };

    return (
        <>
            <ToastContainer autoClose={700} position='top-center' />

            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-flex  align-items-start align-items-sm-center justify-content-between gap-2">
                                <h4 className="mb-2 mb-sm-0">Quotations</h4>
                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item">
                                            <Link to="/dashboard">Dashboard</Link>
                                        </li>
                                        <li className="breadcrumb-item active">Quotations</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    {/* //* header buttons */}
                                    <div
                                        className="d-flex align-items-center justify-content-start mb-3"
                                        style={{ width: "100%" }}
                                    >
                                        <div className='header-input'>
                                            <select name="options" id="optionSelect" className="form-select" value={vendorStat} onChange={(e) => setVendorStat(e.target.value)}>
                                                <option value="3">All</option>
                                                <option value="0">New</option>
                                                <option value="1">Replied</option>
                                                <option value="2">Close</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="table-responsive">
                                        <table className="w-100 text-sm text-left border-collapse custom-stripe-table ">
                                            <thead className="bg-gray-200  text-center">
                                                <tr>
                                                    <th className="px-4 py-2">SN</th>
                                                    <th className="px-4 py-2">Category</th>
                                                    <th className="px-4 py-2">Event Date</th>
                                                    <th className="px-4 py-2">Name</th>
                                                    <th className="px-4 py-2">Location</th>
                                                    <th className="px-4 py-2">Event Type</th>
                                                    <th className="px-4 py-2">Status</th>
                                                    <th className="px-4 py-2">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    data.length > ZERO ?
                                                        data.map((caterer, index) =>
                                                            <tr className="bg-white hover:bg-gray-100">
                                                                <td className="px-4 py-2">{((page - ONE) * REQUESTED_RECORD) + (index + ONE)}</td>
                                                                <td className="px-4 py-2">{caterer.vendor?.category === ONE ? 'Mobile Bar' : 'Caterer'}</td>
                                                                <td className="px-4 py-2">{caterer.event_date} <br /> ({caterer.event_start_time + ' to ' + caterer.event_end_time})</td>
                                                                <td className="px-4 py-2 text-nowrap">{caterer.full_name} <br />({caterer.email})</td>
                                                                <td className="px-4 py-2">{caterer.address}</td>
                                                                <td className="px-4 py-2">{caterer.event_type}</td>
                                                                <td className="px-4 py-2">
                                                                    <span className={`badge ${caterer.status == ZERO ? 'badge-primary-lighten' : caterer.status == ONE ? 'badge-secondary-lighten' : 'badge-danger-lighten'}`}>
                                                                        {caterer.status == ZERO ? 'NEW' : caterer.status == ONE ? 'REPLIED' : 'CLOSE'}
                                                                    </span>
                                                                </td>
                                                                <td className="px-4 py-2">
                                                                    <MdRemoveRedEye
                                                                        size={20}
                                                                        data-tooltip-id='view' data-tooltip-content="View Quotation"
                                                                        className=' text-warning vendor-icon pointer user-status fs-5'
                                                                        onClick={() => {
                                                                            caterer.vendor?.category === ONE ?
                                                                                navigate('/quotation/view-mobile', {
                                                                                    state: {
                                                                                        quotationData: caterer
                                                                                    }
                                                                                })
                                                                                :
                                                                                navigate('/quotation/view-caterer', {
                                                                                    state: {
                                                                                        quotationData: caterer
                                                                                    }
                                                                                })
                                                                        }}
                                                                    />
                                                                    <Tooltip id='view' place="bottom" effect="solid" />
                                                                </td>
                                                            </tr>
                                                        )
                                                        :
                                                        <tr>
                                                            <td colSpan={8} className='text-center'>No data found!</td>
                                                        </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* //* pagination */}
                                    {
                                        data.length > ZERO &&
                                        <div className='float-end'>
                                            <ReactPaginate
                                                className='pagination'
                                                onPageChange={handlePageChange}
                                                pageCount={totalPages}
                                                forcePage={(totalPages > ZERO) && (page <= totalPages) ? (page - ONE) : ZERO}
                                                previousLabel={<MdKeyboardArrowLeft className='fs-4' />}
                                                nextLabel={<MdKeyboardArrowRight className='fs-4' />}
                                                marginPagesDisplayed={TWO}
                                                pageRangeDisplayed={TWO}
                                                breakLabel={'..'}
                                                breakLinkClassName={'disabled-break'}
                                                containerClassName={'pagination-container'}
                                                activeClassName={'pagination-active-page'}
                                            />
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AllQuotation;